export default __webpack_public_path__ + "static/media/image18.5e32bf32.jpg";